'use es6';

import keyMirror from 'react-utils/keyMirror';
export const MODAL_TYPES = Object.freeze(keyMirror({
  DELETE: null,
  PORTAL_COPY_WIZARD: null,
  BULK_DELETE: null,
  BULK_MOVE: null,
  DELETE_FOLDER: null,
  BULK_PORTAL_COPY_WIZARD: null,
  CREATE_CONTENT: null,
  CREATE_CHILD_THEME_WIZARD: null,
  CHILD_THEME_ADD_WIZARD: null,
  MOVE_ASSET: null,
  THEME_DUPLICATE: null,
  ASSET_PORTAL_COPY: null,
  SHOW_INFORMATION: null,
  PLAN_DOWNGRADE: null
}));